<template>
  <div class="content-block">
    <ProjectTypeForm
      :projectTypeId="projectTypeId"
      @done="onDone"
    ></ProjectTypeForm>
  </div>
</template>

<script>
import ProjectTypeForm from 'CORE/components/project/type/form'
import isString from 'lodash/isString'
import get from 'lodash/get'

export default {
    name: 'ProjectTypeEdit',
    components: {
        ProjectTypeForm,
    },
    computed: {
        projectTypeId() {
            const id = get(this.$route.params, 'id')
            console.assert(isString(id), `ID must be a string`) // TODO check if id is valid uuid or not
            return id
        },
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'projectTypesList' })
        },
    },
}
</script>
